import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  switchMap,
  map,
  share,
  catchError,
  withLatestFrom,
  repeat,
} from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { HttpService } from '@toro/common/shared/services/http/http.service';
import { SettingsService } from '@toro/common/shared/services/settings/settings.service';
import { HttpHeaders } from '@angular/common/http';
import { UsersState } from '@toro/common/shared/state-management/users/users.reducer';
import { TraderClubActions } from './club-trader.actions';

@Injectable()
export class TraderClubEffects {
  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private httpService: HttpService,
    private settings: SettingsService
  ) {}

  getProfileTrader$ = createEffect(() => this.actions$.pipe(
    ofType(TraderClubActions.getProfileTrader),
    withLatestFrom(this.store.select((authStore) => authStore.authentication)),
    switchMap(([_, auth]) => {
      const apiUrl = this.settings.getConfigurationKeyValue('backend');
      const isLogged = !!(auth.currentUser && auth.currentUser.token);
      return this.httpService
        .get<any>(
          `${apiUrl.api}/trader/real`,
          this._createHeaders(auth, isLogged)
        )
        .pipe(
          map((traderResponse: any) => {
            if (traderResponse) {
              return {
                type: TraderClubActions.getProfileTraderSuccess,
                payload: traderResponse,
              };
            } else {
              return {
                type: TraderClubActions.getProfileTraderError,
                payload: {},
              };
            }
          })
        );
    }),
    catchError((error) =>
      of({ type: TraderClubActions.getProfileTraderError, payload: error })
    ),
    repeat(),
    share()
  ));

  private _createHeaders(userData: UsersState, logged: boolean = false) {
    if (!logged) {
      return new HttpHeaders({
        'Content-Type': 'application/json; charset=UTF-8',
        'X-SessionID': `${userData.sessionID}`,
      });
    } else {
      return new HttpHeaders({
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${userData.currentUser.token}`,
      });
    }
  }
}
